import { render } from "./index.vue?vue&type=template&id=0d338a60"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__